const FirmalarRoutePoints = {
    addressName:"",
    address:"",
    city:"",
    country:"",
    routeLocation:""
}
export default FirmalarRoutePoints